import { render, staticRenderFns } from "./MyTeamMembers.vue?vue&type=template&id=1b1788bf&"
import script from "./MyTeamMembers.vue?vue&type=script&lang=js&"
export * from "./MyTeamMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports